import { Variants } from 'framer-motion';

export const CHILDREN_VARIANTS: Variants = {
  hidden: {
    x: -20,
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
  },
};
